module.exports = __webpack_public_path__ + "img/GH-corporate-top002sp.eee44d5d.png";